import React, { useContext, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { numberFormat } from 'helper';
import * as actions from '../../../action';
import * as c from '../../../constant';
import LandAppraisalModal from '../modals/LandAppraisalModal';
import LandMarketValueContainer from '../land-market-value/container/LandMarketValueContainer';
import AddMarketValueModal from '../land-market-value/component/AddMarketValueModal';

function LandAppraisalContainer({
  getLandAppraisalList,
  getHistoryAppraisalList,
  landAppraisalList,
  applicationInfo,
  removeLandAppraisal,
  type,
  getLandPropertyAssessmentList,
  isLoading,
  ordinanceRevisionId,
}) {
  const setModal = useContext(ModalContext);
  const [showMarketValue, setShowMarketValue] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedValue, setSelectedValue] = useState('');

  const handleAddLandMarketValue = (id) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <AddMarketValueModal
          applicationId={applicationInfo.id}
          landAppraisalId={id}
          ordinanceRevisionId={ordinanceRevisionId}
        />
      ),
      title: 'Add Market Value',
      modalSize: 'modal-md',
    });
  };

  const handleAddLandAppraisal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <LandAppraisalModal
          applicationId={applicationInfo.id}
          ordinanceRevisionId={ordinanceRevisionId}
          type="NEW"
        />
      ),
      title: 'Add Land Appraisal',
      modalSize: 'modal-lg',
    });
  };

  const handleUpdateLandAppraisal = (id, data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <LandAppraisalModal
          type="EDIT"
          updateList={data.attributes}
          id={data.id}
          applicationId={applicationInfo.id}
          ordinanceRevisionId={ordinanceRevisionId}
          landAppraisalInfo={data}
        />
      ),
      title: 'Update Land Appraisal',
      modalSize: 'modal-lg',
    });
  };

  const handleRemoveLandAppraisal = (id, data) => (e) => {
    e.preventDefault();

    ConfirmAlert(
      'Are you sure you want to remove this appraisal?',
      () => {
        removeLandAppraisal(id, data.id, () => {
          getLandPropertyAssessmentList(id);
          return type !== 'history'
            ? getLandAppraisalList(id)
            : getHistoryAppraisalList(id);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleShowMarketValue = (index, id) => () => {
    setSelectedIndex(index);
    setSelectedValue(id);

    if (index === selectedIndex && showMarketValue === false) {
      setShowMarketValue(true);
    }

    if (index === selectedIndex && showMarketValue === true) {
      setShowMarketValue(false);
    }
  };

  useEffect(() => {
    if (_.isEmpty(applicationInfo.id)) return;
    if (type === 'history') getHistoryAppraisalList(applicationInfo.id);
    else getLandAppraisalList(applicationInfo.id);
  }, []);
  useEffect(() => {
    if (_.isEmpty(applicationInfo.id)) return;
    if (type === 'history') getHistoryAppraisalList(applicationInfo.id);
    else getLandAppraisalList(applicationInfo.id);
  }, [applicationInfo.id]);

  return (
    <div className="card-content-listing">
      <div className="card p-0 mr-2">
        {isLoading ? (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        ) : (
          <>
            <div className="row my-3 mx-2">
              {type !== 'history' &&
                ['CANCELLED'].indexOf(
                  _.get(applicationInfo, 'attributes.status')
                ) <= -1 &&
                _.get(applicationInfo, 'attributes.status') !== 'POSTED' && (
                  <div className="col-12 d-flex justify-content-end">
                    <button
                      onClick={handleAddLandAppraisal}
                      type="button"
                      className="btn btn-primary cms-bg-color-primary cms-outline-primary  mb-2"
                    >
                      <i className="fas fa-plus" /> Add Land Appraisal
                    </button>
                  </div>
                )}
              <div style={{ overflowX: 'auto' }}>
                <table
                  className="table table-borderless table-sm table-light"
                  style={{ width: '1000px', overflowX: 'auto' }}
                >
                  <thead className="table-header">
                    <tr>
                      <td widtd="50" />
                      <td className="font-weight-bold">Classification</td>
                      <td className="font-weight-bold">Sub Classification</td>
                      <td className="font-weight-bold">Actual Use</td>
                      <td className="font-weight-bold">Area</td>
                      <td className="font-weight-bold">Unit Value</td>
                      <td className="font-weight-bold">Base Market Value</td>
                      {type !== 'history' && (
                        <td className="font-weight-bold">Actions</td>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {landAppraisalList && landAppraisalList.length <= 0 && (
                      <tr className="text-center">
                        <td colSpan="7">No data</td>
                      </tr>
                    )}
                    {landAppraisalList &&
                      landAppraisalList.map((item, i) => (
                        <React.Fragment key={item.id}>
                          <tr>
                            <td>
                              <button
                                type="button"
                                className="btn-blank"
                                onClick={handleShowMarketValue(i, item.id)}
                              >
                                <i
                                  className={`fa icon-right ${
                                    showMarketValue === true &&
                                    selectedValue === item.id
                                      ? 'fa-caret-up'
                                      : 'fa-caret-right'
                                  }`}
                                />
                              </button>
                            </td>
                            <td>
                              <span style={{ color: '#65676b' }}>
                                {_.get(item, 'attributes.classification')}
                              </span>
                            </td>
                            <td>
                              <span style={{ color: '#65676b' }}>
                                {_.get(item, 'attributes.sub_classification')}
                              </span>
                            </td>
                            <td>
                              <span style={{ color: '#65676b' }}>
                                {_.get(item, 'attributes.actual_use') || '--'}
                              </span>
                            </td>
                            <td>
                              <span style={{ color: '#65676b' }}>
                                {numberFormat(
                                  _.get(item, 'attributes.area'),
                                  2
                                )}
                              </span>
                            </td>
                            <td>
                              <span style={{ color: '#65676b' }}>
                                {numberFormat(
                                  _.get(item, 'attributes.unit_value'),
                                  2
                                )}
                              </span>
                            </td>
                            <td>
                              <span style={{ color: '#65676b' }}>
                                {numberFormat(
                                  _.get(item, 'attributes.base_market_value'),
                                  2
                                )}
                              </span>
                            </td>
                            {type !== 'history' &&
                              _.get(applicationInfo, 'attributes.status') !==
                                'POSTED' &&
                              ['CANCELLED'].indexOf(
                                _.get(applicationInfo, 'attributes.status')
                              ) <= -1 && (
                                <td className="text-center">
                                  <button
                                    onClick={handleUpdateLandAppraisal(
                                      applicationInfo.id,
                                      item
                                    )}
                                    type="button"
                                    className="btn-blank"
                                  >
                                    <i className="far fa-edit icon-edit" />
                                  </button>
                                  <button
                                    type="button"
                                    className="btn-blank"
                                    onClick={handleRemoveLandAppraisal(
                                      applicationInfo.id,
                                      item
                                    )}
                                  >
                                    <i className="far fa-trash-alt icon-delete" />
                                  </button>
                                </td>
                              )}
                          </tr>
                          <tr>
                            {type !== 'history' &&
                              _.get(applicationInfo, 'attributes.status') !==
                                'POSTED' &&
                              ['CANCELLED'].indexOf(
                                _.get(applicationInfo, 'attributes.status')
                              ) <= -1 && (
                                <>
                                  {showMarketValue === true &&
                                    i === selectedIndex && (
                                      <>
                                        <th colSpan="7" />
                                        <td style={{ width: '165px' }}>
                                          <button
                                            onClick={handleAddLandMarketValue(
                                              item.id
                                            )}
                                            type="button"
                                            className="btn btn-primary cms-bg-color-primary cms-outline-primary  mb-2"
                                          >
                                            Add Market Value
                                          </button>
                                        </td>
                                      </>
                                    )}
                                </>
                              )}
                          </tr>
                          <tr>
                            {showMarketValue === true &&
                              i === selectedIndex && (
                                <td colSpan="9">
                                  <LandMarketValueContainer
                                    applicationInfo={applicationInfo}
                                    landAppraisalId={item.id}
                                    type={type}
                                    ordinanceRevisionId={ordinanceRevisionId}
                                  />
                                </td>
                              )}
                          </tr>
                        </React.Fragment>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
    // </div>
  );
}

LandAppraisalContainer.defaultProps = {
  type: '',
  applicationInfo: {},
};

LandAppraisalContainer.propTypes = {
  getLandAppraisalList: PropTypes.instanceOf(Function).isRequired,
  getHistoryAppraisalList: PropTypes.instanceOf(Function).isRequired,
  landAppraisalList: PropTypes.instanceOf(Array).isRequired,
  applicationInfo: PropTypes.instanceOf(Object),
  removeLandAppraisal: PropTypes.instanceOf(Function).isRequired,
  type: PropTypes.string,
  getLandPropertyAssessmentList: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }) => ({
  landAppraisalList: _.get(api, `${c.GET_LAND_APPRAISAL}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_LAND_APPRAISAL) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(LandAppraisalContainer);
